import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between p-4 bg-white dark:border-gray-800 shadow-md rounded-lg" }
const _hoisted_2 = { class: "font-medium text-gray-800" }
const _hoisted_3 = { class: "text-sm text-gray-500" }
const _hoisted_4 = { class: "flex items-center gap-4" }

import { ref, watch } from 'vue';

  // Пропсы
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PageNavigation',
  props: {
    title: {},
    totalPages: {},
    activePage: {}
  },
  emits: ["update:currentPage"],
  setup(__props: any, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const currentPage = ref(props.activePage);

  const nextPage = () => {
    if (currentPage.value < props.totalPages) {
      currentPage.value++;
    }
  };

  const prevPage = () => {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  };

  watch(currentPage, (newValue) => {
    emit('update:currentPage', newValue);
  });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(currentPage.value) + " / " + _toDisplayString(_ctx.totalPages), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        icon: "pi pi-arrow-left",
        onClick: prevPage,
        disabled: currentPage.value === 1
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        icon: "pi pi-arrow-right",
        onClick: nextPage,
        disabled: currentPage.value === _ctx.totalPages
      }, null, 8, ["disabled"])
    ])
  ]))
}
}

})